import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import Modal from '../../components/Modal';
import { apiFetch } from '../../lib/api';
import { Rischio } from '../../types';

type FormData = { nome: string; descrizione: string };
const EMPTY: FormData = { nome: '', descrizione: '' };

export default function RischiPage() {
  const [items,   setItems]   = useState<Rischio[]>([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState('');
  const [modal,   setModal]   = useState(false);
  const [form,    setForm]    = useState<FormData>({ ...EMPTY });
  const [editId,  setEditId]  = useState<number | null>(null);
  const [saving,  setSaving]  = useState(false);

  const load = async () => {
    try {
      const d = await apiFetch<{ rischi: Rischio[] }>('/api/assicurazioni/rischi');
      setItems(d.rischi);
    } catch (e: any) { setError(e.message); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const openCreate = () => { setForm({ ...EMPTY }); setEditId(null); setError(''); setModal(true); };
  const openEdit   = (r: Rischio) => {
    setForm({ nome: r.nome, descrizione: r.descrizione || '' });
    setEditId(r.id); setError(''); setModal(true);
  };
  const closeModal = () => { setModal(false); setError(''); };

  const save = async () => {
    if (!form.nome) { setError('Nome obbligatorio'); return; }
    setSaving(true);
    try {
      const body = { nome: form.nome, descrizione: form.descrizione || null };
      if (editId) await apiFetch(`/api/assicurazioni/rischi/${editId}`, { method: 'PUT', body: JSON.stringify(body) });
      else        await apiFetch('/api/assicurazioni/rischi',           { method: 'POST', body: JSON.stringify(body) });
      closeModal(); load();
    } catch (e: any) { setError(e.message); }
    finally { setSaving(false); }
  };

  const del = async (r: Rischio) => {
    if (!window.confirm(`Eliminare "${r.nome}"?`)) return;
    try {
      await apiFetch(`/api/assicurazioni/rischi/${r.id}`, { method: 'DELETE' });
      load();
    } catch (e: any) { setError(e.message); }
  };

  return (
    <Layout>
      <div className="bop-page-header">
        <div className="bop-page-header__text">
          <h2 className="bop-page-title">Rischi aziendali</h2>
          <p className="bop-page-subtitle">Catalogo dei rischi assicurabili</p>
        </div>
        <button className="bop-btn bop-btn-primary" onClick={openCreate}>+ Nuovo rischio</button>
      </div>

      {error && !modal && <div className="bop-alert bop-alert--danger">{error}</div>}

      <div className="bop-card">
        <div className="bop-table-wrapper">
          {loading ? <div className="bop-empty-state">Caricamento…</div> : items.length === 0 ? (
            <div className="bop-empty-state">Nessun rischio configurato.</div>
          ) : (
            <table className="bop-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Descrizione</th>
                  <th className="bop-rischi__col-assoc">Associazioni</th>
                  <th className="bop-rischi__col-actions"></th>
                </tr>
              </thead>
              <tbody>
                {items.map((r) => (
                  <tr key={r.id}>
                    <td><strong>{r.nome}</strong></td>
                    <td className="bop-text-muted">{r.descrizione || '—'}</td>
                    <td className="bop-rischi__assoc-cell">{r.n_associazioni ?? 0}</td>
                    <td>
                      <div className="bop-rischi__actions">
                        <button className="bop-btn bop-btn-ghost" onClick={() => openEdit(r)}>Modifica</button>
                        <button
                          className="bop-btn bop-btn-ghost bop-text-danger"
                          onClick={() => del(r)}
                          disabled={(r.n_associazioni ?? 0) > 0}
                          title={(r.n_associazioni ?? 0) > 0 ? 'Ha associazioni — eliminarle prima' : ''}
                        >
                          Elimina
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {modal && (
        <Modal
          title={editId ? 'Modifica rischio' : 'Nuovo rischio'}
          onClose={closeModal}
          footer={
            <><button className="bop-btn bop-btn-secondary" onClick={closeModal}>Annulla</button>
              <button className="bop-btn bop-btn-primary" onClick={save} disabled={saving}>
                {saving ? 'Salvo…' : 'Salva'}
              </button></>
          }
        >
          {error && <div className="bop-alert bop-alert--danger">{error}</div>}
          <div className="bop-form-group">
            <label className="bop-label">Nome <span className="bop-text-danger">*</span></label>
            <input className="bop-input" value={form.nome}
              onChange={(e) => setForm({ ...form, nome: e.target.value })} />
          </div>
          <div className="bop-form-group">
            <label className="bop-label">Descrizione</label>
            <textarea className="bop-input bop-rischi__textarea" rows={3} value={form.descrizione}
              onChange={(e) => setForm({ ...form, descrizione: e.target.value })} />
          </div>
        </Modal>
      )}
    </Layout>
  );
}
